import React, { Component } from "react";
import ParticlesBg from "particles-bg";
import Fade from "react-reveal";

class Header extends Component {
  render() {
    if (!this.props.data) return null;

    return (
      <header id="home">
        <ParticlesBg type="cobweb" color="#5c5c5c" bg={true} />

        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            Hide navigation
          </a>

          <ul id="nav" className="nav">
            <li className="current">
              <a className="smoothscroll" href="#home">
                Introduction
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#about">
                Arquitecture
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#resume">
                Hardware & Software
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#portfolio">
                Results
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#contact">
                References
              </a>
            </li>
          </ul>
        </nav>

        <div className="row banner">
          <div className="banner-text">
            <Fade bottom>
            <h1>What?</h1>
            <h3>
              SmartChess is a chess board that detects the moves played and points illegal moves made by Marcos Garralaga (1210382@isep.ipp.pt) for the LABSI course.
            </h3>
            </Fade>
            <Fade bottom duration={1200}>
            <h1>Why?</h1>
            <h3>
              Nowadays the only anti-cheating measure implemented in proffesional "on the board" tournaments
              are the figure of the referee (that <a href="https://chess24.com/en/read/news/what-happened-in-carlsen-vs-firouzja">has been proved not sufficient </a> numerous times because of 
              human error) and the <a href="images/scoreSheet.png">score sheet</a>, a representation of the game that is considered an obstacle
              in some modalities of timed games: When each player is given low time (3-5 minutes) half of the time
              would be wasted at writing moves in the sheet and not thinking/playing.
              SmartChess fusions this measures and lowers the entry barrier for proffesional play in chess.
            </h3>
            </Fade>
            <Fade bottom duration={2000}>
            <h1>How?</h1>
            <h3>
              A custom chess board and set with magnets was developed. Using an microprocessor all the moves are processed and checked, finally sent to a computer for displaying or livestreaming.
            </h3>
            </Fade>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
